// Aquargin YouTube Channel Videos Configuration
// Channel: https://www.youtube.com/@nocodeAquargin
// Replace these placeholder video IDs with actual video IDs from your channel

export const YOUTUBE_CHANNEL = {
  url: 'https://www.youtube.com/@nocodeAquargin',
  handle: '@nocodeAquargin'
};

// Platform Demo Videos
export const PLATFORM_VIDEOS = {
  overview: {
    id: '6qQ4V7AWbrw', // Replace with your platform overview video ID
    title: 'Aquargin Platform Introduction',
    description: 'See how Aquargin\'s unified platform transforms business operations from end to end.'
  },
  gettingStarted: {
    id: '9XYaW3R7Xw', // Replace with your getting started video ID
    title: 'Platform Overview & Setup',
    description: 'Complete guide to getting started with Aquargin\'s enterprise platform and initial configuration.'
  },
  advancedFeatures: {
    id: 'REPLACE_WITH_ACTUAL_VIDEO_ID', // Replace with your advanced features video ID
    title: 'Advanced Automation & AI Features',
    description: 'Deep dive into advanced automation capabilities, AI features, and enterprise integrations.'
  }
};

// Customer Success Story Videos
export const SUCCESS_STORY_VIDEOS = {
  delhiHealthCentre: {
    id: 'REPLACE_WITH_ACTUAL_VIDEO_ID', // Replace with Delhi Health Centre case study video ID
    title: 'Delhi Health Centre Transformation',
    company: 'Healthcare Enterprise',
    metric: '60% Cost Reduction',
    description: 'See how we automated their entire patient management system'
  },
  warpEduTech: {
    id: 'REPLACE_WITH_ACTUAL_VIDEO_ID', // Replace with WarpEduTech case study video ID
    title: 'WarpEduTech Educational Success',
    company: 'Educational Technology',
    metric: '40% Efficiency Gain',
    description: 'Complete educational operations automation and optimization'
  },
  shereBengal: {
    id: 'REPLACE_WITH_ACTUAL_VIDEO_ID', // Replace with Sher-e-bengal case study video ID
    title: 'Sher-e-bengal Digital Journey',
    company: 'Financial Services',
    metric: '300% ROI Achieved',
    description: 'Marketing automation and business intelligence transformation'
  },
  hamTraders: {
    id: 'REPLACE_WITH_ACTUAL_VIDEO_ID', // Replace with HAM Traders case study video ID
    title: 'HAM Traders FMCG Innovation',
    company: 'Import/Export Business',
    metric: '50% Process Improvement',
    description: 'Streamlined operations across multiple markets'
  }
};

// Product Tutorial Videos
export const PRODUCT_TUTORIAL_VIDEOS = {
  aquaCare: {
    id: 'REPLACE_WITH_ACTUAL_VIDEO_ID', // Replace with AquaCare tutorial video ID
    product: 'AquaCare',
    category: 'Healthcare',
    views: '12K'
  },
  aquaInvoice: {
    id: 'REPLACE_WITH_ACTUAL_VIDEO_ID', // Replace with AquaInvoice tutorial video ID
    product: 'AquaInvoice',
    category: 'Finance',
    views: '8.5K'
  },
  aquaCRM: {
    id: 'REPLACE_WITH_ACTUAL_VIDEO_ID', // Replace with AquaCRM tutorial video ID
    product: 'AquaCRM',
    category: 'CRM',
    views: '15K'
  },
  aquaHR: {
    id: 'REPLACE_WITH_ACTUAL_VIDEO_ID', // Replace with AquaHR tutorial video ID
    product: 'AquaHR',
    category: 'Advanced',
    views: '6.2K'
  }
};

// Helper function to create YouTube embed URL
export const createYouTubeEmbedUrl = (videoId, options = {}) => {
  const params = new URLSearchParams({
    modestbranding: '1',
    rel: '0',
    showinfo: '0',
    ...options
  });
  
  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
};

// Helper function to validate video ID (basic check)
export const isValidVideoId = (videoId) => {
  return videoId && videoId !== 'REPLACE_WITH_ACTUAL_VIDEO_ID' && videoId.length === 11;
};

// Fallback function for missing videos - redirects to channel
export const handleMissingVideo = () => {
  window.open(YOUTUBE_CHANNEL.url, '_blank');
}; 